var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modals"},[_c('new-diagram-modal'),_c('load-diagram-modal'),_c('save-as-diagram-modal'),_c('login-modal'),_c('signup-modal'),_c('profile-modal'),_c('password-modal'),_c('message-modal'),_c('progress-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }